export const dateZh = (str) => {
  const dateObj = new Date(str)
  const year = dateObj.getFullYear()
  const month = dateObj.getMonth() + 1
  const date = dateObj.getDate()
  return `${year}年${month}月${date}日`
}